// StaticDestinationTable.styles.tsx
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledStaticDestinationTable = styled.div`
  .section {
    margin: 0 0 ${toRem(24)} 0;
    padding: ${toRem(16)};
    border: ${toRem(1)} solid ${baseVariables.color.neutral20};
    border-radius: ${toRem(12)};
    background: ${baseVariables.color.base20};
    box-shadow: 0 ${toRem(1)} ${toRem(2)} rgba(16, 24, 40, 0.06);
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${toRem(8)};
  }

  .metro-title {
    margin: 0 0 ${toRem(8)} 0;
    font-size: ${toRem(22)};
    font-weight: 700;
    color: ${baseVariables.color.base10};
  }

  .meta {
    margin: 0;
    font-size: ${toRem(12)};
    color: ${baseVariables.color.neutral40};
  }

  .table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    background: ${baseVariables.color.base20};
    border-radius: ${toRem(8)};
    overflow: hidden;
    table-layout: fixed;
    min-width: ${toRem(560)};
  }

  .col-prop {
    width: 58%;
    @media ${baseVariables.mediaQuery.lg} {
      width: 55%;
    }
  }
  .col-code {
    width: 20%;
  }
  .col-search {
    width: 22%;
    @media ${baseVariables.mediaQuery.lg} {
      width: 25%;
    }
  }

  .caption {
    text-align: left;
    padding: ${toRem(10)} ${toRem(12)};
    font-size: ${toRem(12)};
    color: ${baseVariables.color.neutral40};
  }

  .thead tr {
    background: ${baseVariables.color.neutral20};
  }

  .thead th {
    position: sticky;
    top: 0;
    text-align: left;
    color: ${baseVariables.color.base10};
    font-weight: 600;
    padding: ${toRem(10)} ${toRem(12)};
    border-bottom: ${toRem(2)} solid ${baseVariables.color.neutral20};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tbody tr {
    background: ${baseVariables.color.base20};
  }

  .tbody td {
    padding: ${toRem(10)} ${toRem(12)};
    border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .code {
    display: inline-block;
    font-size: ${toRem(12)};
    color: ${baseVariables.color.alert30};
    background: ${baseVariables.color.neutral30};
    padding: ${toRem(2)} ${toRem(6)};
    border-radius: ${toRem(6)};
    min-width: ${toRem(48)};
    text-align: center;
    white-space: nowrap;
  }

  .empty {
    padding: ${toRem(10)} ${toRem(12)};
    border: ${toRem(1)} dashed ${baseVariables.color.neutral30};
    border-radius: ${toRem(8)};
    background: ${baseVariables.color.neutral20};
    color: ${baseVariables.color.neutral40};
  }

  .empty-row td {
    text-align: center;
    color: ${baseVariables.color.neutral40};
  }
`;
